import globalUnits from "../units/globalUnits";
import ovdJsonStore from "../stores/OVDJsonStore";
export function bindOvdJsonStoreEvents() {
    ovdJsonStore.addEventListener("jsonLoaded", () => {
        var _a, _b, _c;
        globalUnits.setLpp(((_c = (_b = (_a = ovdJsonStore.currentJson) === null || _a === void 0 ? void 0 : _a.shipData) === null || _b === void 0 ? void 0 : _b.lcgOptions) === null || _c === void 0 ? void 0 : _c.lpp) || 0);
    }, false);
}
